import { Barber } from "../../types";

export const searchBarbers = (query: string, Barbers: Barber[]): Barber[] => {
  if (query === "") {
    return Barbers;
  }

  return Barbers.filter(({ firstname, lastname, active_pob }) => {
    const searchTargets = [
      firstname?.toLowerCase(),
      lastname?.toLowerCase(),
      active_pob?.name.toLowerCase(),
      active_pob?.city.toLowerCase(),
    ];

    return searchTargets.some((value) => value?.includes(query.toLowerCase()));
  });
};
